import { render } from "./MyDownloadFile.vue?vue&type=template&id=971652d6&scoped=true"
import script from "./MyDownloadFile.vue?vue&type=script&lang=js"
export * from "./MyDownloadFile.vue?vue&type=script&lang=js"

import "./MyDownloadFile.vue?vue&type=style&index=0&id=971652d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-971652d6"]])

export default __exports__